import GetInTouch from "../../Components/GetInTouch/GetInTouch";
import AiInnovation from "./AiInnovation/AiInnovation";
import AiUseCases from "./AiUseCases/AiUseCases";
import EnergySolutions from "./EnergySolutions/EnergySolutions";
import classes from "./Solutions.module.scss";

// import useIsMobile from "../../Hooks/useIsMobile";

import { useEffect } from "react";

function Solutions() {
  // const isMobile = useIsMobile(769);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Set the tab name
    document.title =
      "Net-Zero Solutions | Innovative Platforms for Decarbonization";

    // Set the meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Explore our cutting-edge solutions for net-zero transitions. Automate, simplify, and scale your decarbonization efforts with Sustainability Economics."
      );
    } else {
      // If the meta tag doesn't exist, create it
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Explore our cutting-edge solutions for net-zero transitions. Automate, simplify, and scale your decarbonization efforts with Sustainability Economics.";
      document.head.appendChild(meta);
    }

    // Clean up (if necessary) when component unmounts
    return () => {
      document.title = "Default Title"; // Restore the default title
    };
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <img
          className={classes["header-img"]}
          src={
            "https://se-website-image.s3.ap-south-1.amazonaws.com/solutions.jpeg"
          }
          alt="Contact Us"
        />

        <div className={classes.title}>Solutions</div>
      </div>

      <EnergySolutions />
      <AiInnovation />
      <AiUseCases />
      <GetInTouch />
    </div>
  );
}

export default Solutions;
